import React, { Component, PropTypes } from 'react';
import { List as iList } from 'immutable';
import { countries } from '../../../utils/select-fields';
import LeftBarDetail from './left-bar-detail';

class DestinationSold extends Component {

  render() {
    const { profileToShow, editField } = this.props;
    const marketServed = (markets => {
      if (markets && markets.length > 1 && markets[0] === '') {
        return markets.slice(1);
      }
      return markets;
    })(profileToShow.marketServed || profileToShow.markets || iList());

    const marketServedSettings = {
      options: countries,
      type: 'multi',
    };

    return (
      <div id="marketServed">
        <LeftBarDetail
          {...this.props}
          itemName={"Market"}
          infoArray={marketServed}
          title={"Market Served"}
          className="segment-content"
          editField={editField.bind(this, 'marketServed', marketServedSettings)}
        />
      </div>
    );
  }
}

DestinationSold.propTypes = {
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
};

export default DestinationSold;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/marketServed.jsx